(() => {
  if (customElements.get('announcement-countdown')) return;

  class AnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.timer = this.querySelector('.timer');
      if (!this.timer) return;
      this.numbers = ['days', 'hrs', 'mins', 'secs'].map(unit => this.timer.querySelector(`.timer__${unit} .timer__number`));
      if (this.numbers.some(number => !number)) return;
      this.scheduled = Boolean(this.dataset.schedule?.trim());
      const timestamp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;
      this.windows = (this.dataset.schedule || '').split('\n').filter(line => line.trim()).map(line => {
        const parts = line.split('|').map(part => part.trim());
        if (parts.length !== 2 || !parts.every(part => timestamp.test(part))) return null;
        const [start, end] = parts.map(Date.parse);
        return Number.isFinite(start) && Number.isFinite(end) && start < end ? { start, end } : null;
      });
      this.invalidSchedule = this.windows.some(window => !window);
      if (!this.invalidSchedule) this.windows.sort((a, b) => a.start - b.start);
      const date = this.dataset.end || '';
      const local = date.match(/^(\d{4})-(\d{2})-(\d{2})(?: (\d{2}):(\d{2})(?::(\d{2}))?)?$/);
      this.legacyEnd = local
        ? new Date(+local[1], +local[2] - 1, +local[3], +(local[4] || 0), +(local[5] || 0), +(local[6] || 0)).getTime()
        : Date.parse(date);
      this.update = () => {
        const now = Date.now();
        const active = !this.invalidSchedule && this.windows.find(window => now >= window.start && now < window.end);
        const legacyAllowed = !this.scheduled || (!this.invalidSchedule && this.windows.length && now < this.windows[0].start && now < this.legacyEnd);
        const end = active ? active.end : legacyAllowed ? this.legacyEnd : NaN;
        const diff = end - now;
        this.style.display = !Number.isFinite(diff) || (this.scheduled && diff <= 0) ? 'none' : '';
        this.timer.style.display = this.dataset.hideExpired === 'true' && diff <= 0 ? 'none' : '';
        const seconds = Number.isFinite(diff) ? Math.max(0, Math.floor(diff / 1000)) : 0;
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        this.numbers.forEach((number, index) => { number.textContent = String(values[index]).padStart(2, '0'); });
      };
      this.resume = () => {
        clearInterval(this.interval);
        this.update();
        if (!document.hidden) this.interval = setInterval(this.update, 1000);
      };
      document.addEventListener('visibilitychange', this.resume);
      this.resume();
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.resume);
    }
  }

  customElements.define('announcement-countdown', AnnouncementCountdown);
})();
